"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var axios_handlers_1 = require("./axios-handlers");
var axiosInstance = axios_1.default.create();
axiosInstance.interceptors.request.use(axios_handlers_1.requestHandler);
axiosInstance.interceptors.response.use(axios_handlers_1.responseHandler, axios_handlers_1.errorHandler);
/**
 * AxiosClientService - wrapper for Axios native methods providing default config and headers for HTTP calls.
 * @class
 * @private This namespace is only to be used internally
 */
var AxiosClientService = /** @class */ (function () {
    function AxiosClientService() {
    }
    /**Axios `GET` method wrapper
     * @param { string } url
     * @param { Array } params
     * @returns { Promise<AxiosResponse<any> | {}> }
     */
    AxiosClientService.prototype.get = function (url, params, headers) {
        if (params === void 0) { params = {}; }
        if (headers === void 0) { headers = {}; }
        return axiosInstance
            .get(url, {
            params: params,
            headers: headers,
        })
            .then(function (response) { return response.data; })
            .catch(function (error) {
            throw error;
        });
    };
    /** Axios `POST` method wrapper
     * @param url { string } Endpoint URL
     * @param data { any } Data to write
     */
    AxiosClientService.prototype.post = function (url, data) {
        return axiosInstance
            .post(url, data)
            .then(function (response) { return response.data; })
            .catch(function (error) {
            throw error;
        });
    };
    /** Axios `PUT` method wrapper
     * @param url {string} Endpoint URL
     * @param data {any} Data to write
     */
    AxiosClientService.prototype.put = function (url, data) {
        return axiosInstance
            .put(url, data)
            .then(function (response) { return response.data; })
            .catch(function (error) {
            throw error;
        });
    };
    /** Axios `PATCH` method wrapper
     * @param url { string } Endpoint URL
     * @param data { any } Data to patch
     */
    AxiosClientService.prototype.patch = function (url, data) {
        return axiosInstance
            .patch(url, data)
            .then(function (response) { return response.data; })
            .catch(function (error) {
            throw error;
        });
    };
    /** Axios `DELETE` method wrapper
     * @param url { string } Endpoint URL
     */
    AxiosClientService.prototype.delete = function (url) {
        return axiosInstance
            .delete(url)
            .then(function (response) { return response.data; })
            .catch(function (error) {
            throw error;
        });
    };
    /** Axios `request` method wrapper
     * @param params { object }
     */
    AxiosClientService.prototype.request = function (params) {
        return axiosInstance
            .request(params)
            .then(function (response) { return response.data; })
            .catch(function (error) {
            throw error;
        });
    };
    return AxiosClientService;
}());
/**
 * AxiosClient Instance
 * @namespace
 * @private This namespace is only to be used internally
 */
exports.axiosClientInstance = new AxiosClientService();
